import { Link } from 'gatsby';
import React from 'react';
export default {
  Link,
  React
};